<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  name: "BarChart",
  props: ["data"],
  mounted() {    
    let chartData = {
      labels: [],
      datasets: [
        {
          label: "Проработанность, %",
          backgroundColor: "#0077b4",
          data: []
        },        
      ]
    };

    for (let i = 0; i < this.data.length; i++) {
      chartData.labels.push(this.data[i].name);
      chartData.datasets[0].data.push(this.data[i].ready);
    }

    this.renderChart(chartData, {      
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            stacked: true
          }
        ],
        yAxes: [
          {
            stacked: true
          }
        ]
      },
      legend:{        
        display: false
      }      
    });
  }
};
</script>
